import { Container, Sprite, Texture } from 'pixi.js';
import type { TileModel } from '../../models/board/TileModel';
import { TILE_COLOR_TEXTURE_MAP } from '../../TileColor';

export const TILE_WIDTH = 119;
export const TILE_HEIGHT = 116;
export const TILE_EDGE_LENGTH = 0.8;
export const TILE_Z_OFFSET = 7;

export class TileView extends Container {
  public readonly mainSprite = new Sprite().props({
    parent: this,
  });

  public model: TileModel;

  private defaultTexture!: Texture;

  constructor(model: TileModel) {
    super();
    this.model = model;
    this.setModel(model);
  }

  public setModel(model: TileModel): this {
    this.model = model;
    const textureName = TILE_COLOR_TEXTURE_MAP[model.color];
    this.defaultTexture = Texture.from(textureName);
    this.mainSprite.props({
      anchor: 0.5,
      texture: this.defaultTexture,
    });
    return this;
  }

  public resetView(): void {
    this.zIndex = 0;
    this.removeTweens(true);
    this.rotation = 0;
    this.scale.set(1, 1);
    this.resetTexture();
    this.tint = 0xffffff;
  }

  public resetTexture(): void {
    this.mainSprite.texture = this.defaultTexture;
  }

  public setTexture(texture: Texture | string): void {
    this.mainSprite.props({
      texture,
    });
  }

  set texture(texture: Texture) {
    this.mainSprite.props({
      texture,
    });
  }

  get texture(): Texture {
    return this.mainSprite.texture;
  }
}
